import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-12 md:py-20 px-4 bg-primary-bg" data-id="element-83">
      <div className="max-w-3xl mx-auto" data-id="element-84">
        <div className="bg-card-bg p-6 md:p-12 rounded-2xl md:rounded-3xl border border-gold/30 text-center relative overflow-hidden shadow-lg" data-id="element-85">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1 bg-gold" data-id="element-86" />

          <div className="inline-flex items-center justify-center w-14 h-14 md:w-20 md:h-20 rounded-full bg-gold/10 mb-4 md:mb-6" data-id="element-87">
            <ShieldCheckIcon className="w-7 h-7 md:w-10 md:h-10 text-gold" data-id="element-88" />
          </div>

          <h2 className="font-heading text-xl md:text-2xl lg:text-3xl font-bold text-text-primary mb-4 md:mb-6" data-id="element-89">
            Garantía de Satisfacción
          </h2>

          <p className="text-text-secondary text-sm md:text-lg leading-relaxed mb-5 md:mb-8 font-medium" data-id="element-90">
            Si en los primeros 7 días sentís que esto no es para vos, te
            devolvemos el 100% de tu inversión. Sin preguntas, sin vueltas.
            Creemos en este sistema porque funciona cuando se aplica. Pero si no
            es tu momento, lo respetamos.
          </p>

          <div className="bg-primary-bg p-3 md:p-4 rounded-xl border border-border-gold" data-id="element-91">
            <p className="text-[10px] md:text-xs text-text-muted leading-relaxed" data-id="element-92">
              Este producto es una guía práctica de hábitos y organización
              personal. No reemplaza tratamiento médico, psicológico, legal ni
              financiero profesional. Los resultados dependen de la aplicación
              individual.
            </p>
          </div>
        </div>
      </div>
    </section>;
}